<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-eject`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40.997 38a1 1 0 011 1v2a1 1 0 01-1 1H7.003a1 1 0 01-1-1v-2a1 1 0 011-1h33.994zM25.664 6.89l15.997 24c.886 1.33-.067 3.11-1.664 3.11H8.003c-1.597 0-2.55-1.78-1.664-3.11l15.997-24a2 2 0 013.328 0zM24 11.607L11.74 30h24.52L24 11.606z"/></svg>
</template>
<script>

export default {
  name: 'IconEject',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
